// Reducer-backed state for the drawing mechanic. The reducer and initial state
// are shared (see shared/engine/drawingReducer) so the canvas and the relay
// buffer stay in lockstep; this is just the React binding.

import { useReducer } from 'react';
import { drawingReducer, initialDrawingState } from '@airhead-games/shared';

export { initialDrawingState };

export function useDrawingState() {
  return useReducer(drawingReducer, initialDrawingState);
}
